import React from 'react';
import './App.css';
import Button from '@material-ui/core/Button';


/**
 * 投稿リストコンポーネント
 *
 * @param {*} props
 * @return {*} 
 */
const List = (props) => {

    console.log('@List.js___----->');

    const { state } = props;

    
    /**
     * 投稿データの描画
     *
     * @param {*} post 投稿データ
     * @return {*} 
     */
    const renderPost = (post) => {
        return (
            <React.Fragment>
                <div className='board__comment-title'>
                    <span className='board__comment-title_id'>{post.id}</span>
                    <span className='board__comment-title_name'>{post.name}</span>
                    <span className='board__comment-title_date'>{post.date}</span>
                </div>
                <div className='board__comment-message'>{post.message}</div>
            </React.Fragment>
        );
    }


    /**
     * 前へボタンクリック時の処理
     */
    const handleClickPreview = () => {
        console.log('@List.js___handleClickPreview----->');
        const { posts } = state;
        let currentPage = state.currentPage;
        let offset = state.offset;
        if(currentPage > 1) {
            offset = offset - state.postsPerPage;
            currentPage = currentPage - 1;
        }
        props.onSubmitViews({
            ...state,
            views: posts.slice(offset, offset + state.postsPerPage),
            currentPage: currentPage,
            offset: offset
        });
    }

    /**
     * 次へボタンクリック時の処理
     */
    const handleClickNext = () => {
        console.log('@List.js___handleClickNext----->');
        const { posts } = state;
        let currentPage = state.currentPage;
        let offset = state.offset;
        if(currentPage < state.total) {
            offset = offset + state.postsPerPage;
            currentPage = currentPage + 1;
        }
        props.onSubmitViews({
            ...state,
            views: posts.slice(offset, offset + state.postsPerPage),
            currentPage: currentPage,
            offset: offset
        });
    }

    return (
        <div className="board__main">
            <div className="board__pager">
                <Button
                    variant="contained"
                    onClick={handleClickPreview}
                    disabled={state.currentPage === 1}
                >
                    前へ
                </Button>
                <div className="board__pager-count">{state.currentPage}<span className="board__pager-slash">/</span>{state.total}</div>
                <Button
                    variant="contained"
                    onClick={handleClickNext}
                    disabled={state.currentPage === state.total || state.total === 0}
                >
                    次へ
                </Button>
            </div>
            {
                state.views.map((post, index) => {
                    return (
                        <div className='board__comment' key={post.id}>{renderPost(post)}</div>
                    );
                })
            }
        </div>
    )
}

export default List;
